// covered-by: packages/commons-node/src/services/askPunttProject.spec.ts
import { z } from "zod";

export enum ModelsNames {
  Domain = "Domain",
  Enterprise = "Enterprise",
  Event = "Event",
  User = "User",
  Note = "Note",
  Team = "Team",
  Ticket = "Ticket",
  UserChat = "UserChat",
  AskPunttChat = "AskPunttChat",
  AskPunttProject = "AskPunttProject",
  AskPunttProjectFeed = "AskPunttProjectFeed",
  Workflow = "Workflow",
}

export const modelNamesSchema = z.nativeEnum(ModelsNames);

export enum SubReferenceTypes {
  TicketMessage = "T",
  TicketRevision = "TicketRevision",
  TicketReview = "TicketReview",
}

export const subReferenceTypesSchema = z.nativeEnum(SubReferenceTypes);
